import { boxShadows } from '@eversports/design-tokens/box-shadows'
import Animation from '@eversports/klimt-animations/Animation'
import Button from '@eversports/klimt-primitives/legacy/Button'
import Heading from '@eversports/klimt-primitives/legacy/Heading'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import RegisterAnimation from '../assets/register-animation.lottie'
import { Localized } from '../localization/react'

interface Props {
  handleClick: () => void
  descriptionType: 'joining-a-match' | 'favoriting-venue' | 'adding-a-friend'
}

const LoginOrRegisterDisclaimer = ({ handleClick, descriptionType }: Props) => {
  return (
    <Stack gap={3} alignItems="center">
      <Animation src={RegisterAnimation} style={{ width: 'fit-content' }} loop autoplay />
      <Stack gap={1}>
        <Heading is="h3" variant="large">
          <Localized id="guest-disclaimer-section-title" />
        </Heading>
        <Text sx={{ color: 'darkgray' }}>
          <Localized id="login-or-register-disclaimer-description" params={{ descriptionType }} />
        </Text>
      </Stack>
      <Button variant="primary" sx={{ p: 3 }} onClick={handleClick} fullWidth>
        <Text sx={{ color: 'white', fontWeight: 'bold', textShadow: boxShadows.default, textTransform: 'none' }}>
          <Localized id="guest-disclaimer-section-button" />
        </Text>
      </Button>
    </Stack>
  )
}

export default LoginOrRegisterDisclaimer
